import styles from "./PolicyInput.module.css";
import * as policiesActions from "../../../store/actions/policies";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../shared/ui/input/Input";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { baseTitle, policyInputValidation } from "../../../constants/messages";
import * as appActions from "../../../store/actions/app";
import * as driverightActions from "../../../store/actions/driveright";

function PolicyInput() {
  const dispatch = useDispatch();
  const history = useHistory();
  let [policyInput, setPolicyInput] = useState("");
  let employeeAuthenticated = useSelector(
    (state) => state.user.employeeAuthenticated
  );
  let agentAuthenticated = useSelector(
    (state) => state.user.agentAuthenticated
  );
  let policyVerified = useSelector((state) => state.driveright.policyVerified);
  let [policyEntered, setPolicyEntered] = useState(false);

  const handleInput = (event) => {
    if (event.key === "Enter") {
      const policyNumber = event.target.value;
      if (policyNumber.length === 7) {
        dispatch(
          policiesActions.setActivePolicy({ PolicyNumber: policyNumber })
        );
        dispatch(driverightActions.verifyPolicy());
        setPolicyEntered(true);
      } else {
        dispatch(
          appActions.setAlertModal(true, "error", policyInputValidation)
        );
        setTimeout(() => {
          dispatch(appActions.setAlertModal(false, ""));
        }, 5000);
      }
    }
  };

  useEffect(() => {
    if (policyVerified && policyEntered) {
      history.push("/operators-a");
      setPolicyEntered(false);
    }
  }, [policyVerified, employeeAuthenticated, history, policyEntered]);

  useEffect(() => {
    if (agentAuthenticated) {
      dispatch(appActions.setLoading(false));
    }
  }, [agentAuthenticated, dispatch]);

  useEffect(() => {
    document.title = baseTitle + " - DriveSteady Activation Code";
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className="formRow">
          <span className={styles.active}>
            Enter policy to begin code resend process
          </span>
        </div>
        <Input label="Policy Number" width="50%">
          <input
            type="text"
            value={policyInput}
            onChange={(event) => setPolicyInput(event.target.value)}
            onKeyDown={handleInput}
          />
        </Input>
      </div>
    </>
  );
}

export default PolicyInput;
